import React, { useEffect, useState } from 'react';
import { useHistory, withRouter } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Header from "../componentes/Header";
import Footer from '../componentes/Footer';
import AboutCirc from '../componentes/AboutCirc';
import Business from '../componentes/Business';
import Seccion from '../componentes/Seccion';


function Nosotros() {

  const cambiarImg = (img) =>{
    console.log("ima:",img);
    if(document.getElementById("imgPrincipal")){
      switch(img){
        case 1:
          document.getElementById("imgPrincipal").style.backgroundImage = "url(./img/team/mike.jpg)";
          document.getElementById("cambioNombre").innerHTML= '<a href="https://www.linkedin.com/in/miguel-espinosa-rescala-a8517566/" target="_blank" class="c-white" id="cambioNombre"><i class="fab fa-linkedin mrg-right-10 fs-18"></i>Miguel Ángel Espinosa</a>'
          document.getElementById("puesto").innerText="Chief Executive Officer"
        break;

        case 2:
          document.getElementById("imgPrincipal").style.backgroundImage = "url(./img/team/ric.jpg)";
          document.getElementById("cambioNombre").innerHTML= '<a href="https://www.linkedin.com/in/ricardo-torices-4bb58651/" target="_blank" class="c-white" id="cambioNombre"><i class="fab fa-linkedin mrg-right-10 fs-18"></i>Ricardo Torices</a>'
          document.getElementById("puesto").innerText="Biometric Product Director"
        break;

        case 3:
          document.getElementById("imgPrincipal").style.backgroundImage = "url(./img/team/dahir.jpg)";
          document.getElementById("cambioNombre").innerHTML= '<a href="https://www.linkedin.com/in/dahir-soriano/" target="_blank" class="c-white" id="cambioNombre"><i class="fab fa-linkedin mrg-right-10 fs-18"></i>Dahir Soriano</a>'
          document.getElementById("puesto").innerText="UX Developer Manager"
        break;
        
        case 4:
          document.getElementById("imgPrincipal").style.backgroundImage = "url(./img/team/boris.jpg)";
          document.getElementById("cambioNombre").innerHTML= '<a href="http://www.linkedin.com/in/boris-iruegas-5bb7a599" target="_blank" class="c-white" id="cambioNombre"><i class="fab fa-linkedin mrg-right-10 fs-18"></i>Boris Iruegas</a>'
          document.getElementById("puesto").innerText="iOS Developer"
        break;

        
        case 5:
            document.getElementById("imgPrincipal").style.backgroundImage = "url(./img/team/tony.jpg)";
            document.getElementById("cambioNombre").innerHTML= '<a href="https://www.linkedin.com/in/antonydayanperezaguilar" target="_blank" class="c-white" id="cambioNombre"><i class="fab fa-linkedin mrg-right-10 fs-18"></i>Antony Pérez</a>'
            document.getElementById("puesto").innerText="Full Stack Developer"
        break;

        case 6:
          document.getElementById("imgPrincipal").style.backgroundImage = "url(./img/team/serch.jpg)";
          document.getElementById("cambioNombre").innerHTML= '<a href="https://www.linkedin.com/in/sergio-adri%C3%A1n-ortiz-mata-1672465b/" target="_blank" class="c-white" id="cambioNombre"><i class="fab fa-linkedin mrg-right-10 fs-18"></i>Sergio Ortiz</a>'
          document.getElementById("puesto").innerText="Architecture Director"
        break;

        case 7:
          document.getElementById("imgPrincipal").style.backgroundImage = "url(./img/team/jc.jpg)";
          document.getElementById("cambioNombre").innerHTML= '<a href="https://www.linkedin.com/in/carlosalpharo/" target="_blank" class="c-white" id="cambioNombre"><i class="fab fa-linkedin mrg-right-10 fs-18"></i>Carlos Alfaro</a>'
          document.getElementById("puesto").innerText="Data Products Manager"
        break;

        case 8:
          document.getElementById("imgPrincipal").style.backgroundImage = "url(./img/team/cass.jpg)";
          document.getElementById("cambioNombre").innerHTML= '<a href="https://www.linkedin.com/in/cassandra-evangelina-cazares-escalante-980581105/" target="_blank" class="c-white" id="cambioNombre"><i class="fab fa-linkedin mrg-right-10 fs-18"></i>Cassandra Cázares</a>'
          document.getElementById("puesto").innerText="Competitive Engineering Leader"
        break;

        case 9:
          document.getElementById("imgPrincipal").style.backgroundImage = "url(./img/team/rayo.jpg)";
          document.getElementById("cambioNombre").innerHTML= '<a href="https://www.linkedin.com/in/sergio-ju%C3%A1rez-macuil-ab28b8190/" target="_blank" class="c-white" id="cambioNombre"><i class="fab fa-linkedin mrg-right-10 fs-18"></i>Sergio Juárez</a>'
          document.getElementById("puesto").innerText="Senior Full Stack Lead Developer"
        break;

        case 10:
          document.getElementById("imgPrincipal").style.backgroundImage = "url(./img/team/annie.jpg";
          document.getElementById("cambioNombre").innerHTML= '<a href="https://www.linkedin.com/in/sergio-ju%C3%A1rez-macuil-ab28b8190" target="_blank" class="c-white" id="cambioNombre"><i class="fab fa-linkedin mrg-right-10 fs-18"></i>Anahi Rodriguez</a>'
          document.getElementById("puesto").innerText="Assistant Chief Executive Officer"
        break;

        case 11:
          document.getElementById("imgPrincipal").style.backgroundImage = "url(./img/team/mich.jpg)";
          document.getElementById("cambioNombre").innerHTML= '<a href="https://www.linkedin.com/in/michel-huerta-17a437193" target="_blank" class="c-white" id="cambioNombre"><i class="fab fa-linkedin mrg-right-10 fs-18"></i>Michel Huerta</a>'
          document.getElementById("puesto").innerText="Android Developer"
        break;

        case 12:
          document.getElementById("imgPrincipal").style.backgroundImage = "url(./img/team/armando.jpg";
          document.getElementById("cambioNombre").innerHTML= '<a href="https://www.linkedin.com/in/c-armando-diaz" target="_blank" class="c-white" id="cambioNombre"><i class="fab fa-linkedin mrg-right-10 fs-18"></i>Armando Díaz</a>'
          document.getElementById("puesto").innerText="Android Developer"
        break;

        case 13:
          document.getElementById("imgPrincipal").style.backgroundImage = "url(./img/team/oscar.jpg)";
          document.getElementById("cambioNombre").innerHTML= '<a href="https://www.linkedin.com/in/oscar-espinosa-a9a736146/" target="_blank" class="c-white" id="cambioNombre"><i class="fab fa-linkedin mrg-right-10 fs-18"></i>Oscar Espinosa</a>'
          document.getElementById("puesto").innerText="UX Designer"
        break;

        case 14:
          document.getElementById("imgPrincipal").style.backgroundImage = "url(./img/team/alex.jpg)";
          document.getElementById("cambioNombre").innerHTML= '<a href="https://www.linkedin.com/in/edgar-alejandro-rodriguez-zavala-99304466" target="_blank" class="c-white" id="cambioNombre"><i class="fab fa-linkedin mrg-right-10 fs-18"></i>Alejandro Rodriguez</a>'
          document.getElementById("puesto").innerText="Blockchain Cryptographic \r\n Product Director"
        break;

        default:
          document.getElementById("imgPrincipal").style.backgroundImage = "url(./img/team/mike.jpg)"; 
        break;
      }
    }else{
      console.log("no hay");
    }
    var nombresList = ["mike", "ricardo", "dahir", "boris", "tony", "serch", "jc", "cass", "rayo", "anni", "mich", "sensei", "oscar", "alex"];
    if(img===1){
      //var removeMike = nombresList.splice(1, 1);
      //console.log(removeMike);
      var length = nombresList.length;
      for(var i=0; i < length; i++){
          if(document.getElementById(nombresList[i]).classList.contains("--active")){
              document.getElementById(nombresList[i]).classList.remove("--active")
      }
      document.getElementById("mike").classList.add("--active")
      }
    }
    if(img===2){
      //var removeMike = nombresList.splice(1, 1);
      //console.log(removeMike);
      var length = nombresList.length;
        for(i=0; i < length; i++){
            if(document.getElementById(nombresList[i]).classList.contains("--active")){
                document.getElementById(nombresList[i]).classList.remove("--active")
        }
        document.getElementById("ricardo").classList.add("--active")
        }
    }
    if(img===3){
      //var removeMike = nombresList.splice(1, 1);
      //console.log(removeMike);
      var length = nombresList.length;
        for(i=0; i < length; i++){
            if(document.getElementById(nombresList[i]).classList.contains("--active")){
                document.getElementById(nombresList[i]).classList.remove("--active")
        }
        document.getElementById("dahir").classList.add("--active")
        }
    }
    if(img===4){
      //var removeMike = nombresList.splice(1, 1);
      //console.log(removeMike);
      var length = nombresList.length;
        for(i=0; i < length; i++){
            if(document.getElementById(nombresList[i]).classList.contains("--active")){
                document.getElementById(nombresList[i]).classList.remove("--active")
        }
        document.getElementById("boris").classList.add("--active")
        }
    }
    if(img===5){
      //var removeMike = nombresList.splice(1, 1);
      //console.log(removeMike);
      var length = nombresList.length;
        for(i=0; i < length; i++){
            if(document.getElementById(nombresList[i]).classList.contains("--active")){
                document.getElementById(nombresList[i]).classList.remove("--active")
        }
        document.getElementById("tony").classList.add("--active")
        }
    }
    if(img===6){
      //var removeMike = nombresList.splice(1, 1);
      //console.log(removeMike);
      var length = nombresList.length;
        for(i=0; i < length; i++){
            if(document.getElementById(nombresList[i]).classList.contains("--active")){
                document.getElementById(nombresList[i]).classList.remove("--active")
        }
        document.getElementById("serch").classList.add("--active")
        }
    }
    if(img===7){
      //var removeMike = nombresList.splice(1, 1);
      //console.log(removeMike);
      var length = nombresList.length;
        for(i=0; i < length; i++){
            if(document.getElementById(nombresList[i]).classList.contains("--active")){
                document.getElementById(nombresList[i]).classList.remove("--active")
        }
        document.getElementById("jc").classList.add("--active")
        }
    }
    if(img===8){
      //var removeMike = nombresList.splice(1, 1);
      //console.log(removeMike);
      var length = nombresList.length;
        for(i=0; i < length; i++){
            if(document.getElementById(nombresList[i]).classList.contains("--active")){
                document.getElementById(nombresList[i]).classList.remove("--active")
        }
        document.getElementById("cass").classList.add("--active")
        }
    }
    if(img===9){
      //var removeMike = nombresList.splice(1, 1);
      //console.log(removeMike);
      var length = nombresList.length;
        for(i=0; i < length; i++){
            if(document.getElementById(nombresList[i]).classList.contains("--active")){
                document.getElementById(nombresList[i]).classList.remove("--active")
        }
        document.getElementById("rayo").classList.add("--active")
        }
    }
    if(img===10){
      //var removeMike = nombresList.splice(1, 1);
      //console.log(removeMike);
      var length = nombresList.length;
        for(i=0; i < length; i++){
            if(document.getElementById(nombresList[i]).classList.contains("--active")){
                document.getElementById(nombresList[i]).classList.remove("--active")
        }
        document.getElementById("anni").classList.add("--active")
        }
    }
    if(img===11){
      //var removeMike = nombresList.splice(1, 1);
      //console.log(removeMike);
      var length = nombresList.length;
        for(i=0; i < length; i++){
            if(document.getElementById(nombresList[i]).classList.contains("--active")){
                document.getElementById(nombresList[i]).classList.remove("--active")
        }
        document.getElementById("mich").classList.add("--active")
        }
    }
    if(img===12){
      //var removeMike = nombresList.splice(1, 1);
      //console.log(removeMike);
      var length = nombresList.length;
        for(i=0; i < length; i++){
            if(document.getElementById(nombresList[i]).classList.contains("--active")){
                document.getElementById(nombresList[i]).classList.remove("--active")
        }
        document.getElementById("sensei").classList.add("--active")
        }
    }
    if(img===13){
      //var removeMike = nombresList.splice(1, 1);
      //console.log(removeMike);
      var length = nombresList.length;
        for(i=0; i < length; i++){
            if(document.getElementById(nombresList[i]).classList.contains("--active")){
                document.getElementById(nombresList[i]).classList.remove("--active")
        }
        document.getElementById("oscar").classList.add("--active")
        }
    }
    if(img===14){
      //var removeMike = nombresList.splice(1, 1);
      //console.log(removeMike);
      var length = nombresList.length;
        for(i=0; i < length; i++){
            if(document.getElementById(nombresList[i]).classList.contains("--active")){
                document.getElementById(nombresList[i]).classList.remove("--active")
        }
        document.getElementById("alex").classList.add("--active")
        }
    }
  }




  return (
    <div>
      <Header></Header>
      
      <div className="base-page">
        <div>
          
          <Seccion theme='dark' id="dicio-about">

            <div className="paralax" style={{position:"relative"}}>
              <div className="secPad" style={{position:"relative", paddingLeft:"90px"}}>

                
                <div className="c-white">
                  <Row className="">
                    <Col md={12} className="center">
                      <h2 class=" title c-white mrg-bt-10 line-height-title letter-spacing-3px mrg-right-60 fw-black fs-60"> 
                        WHAT IS DICIO?
                      </h2>
                    </Col>

                    <Col md={12} lg={5} className="leftt" style={{paddingTop:"50px"}}>
                      <Row className="">
                        <Col md={12}>
                          <Row className="">
                            <Col xs={12} sm={3} md={3}>
                              <img src="./img/shooting.svg" alt="" style={{maxWidth: "150px", width: "100%"}}/>
                            </Col>
                            
                            <Col xs={12} sm={9} md={9}>
                              <Row className="">
                                <Col md={12}>
                                  <p class="fw-bold c-blue fs-30">
                                    Our Purpose:
                                  </p>
                                </Col>

                                <Col md={12}>
                                  <p>Simplify the interactions of society.</p>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>

                        <Col md={12}>
                          <Row className="">
                            <Col xs={12} sm={3} md={3}>
                              <img src="./img/blue-eye.svg" alt="" style={{maxWidth: "150px", width: "100%"}}/>
                            </Col>
                            
                            <Col xs={12} sm={9} md={9}>
                              <Row className="">
                                <Col md={12}>
                                  <p class="fw-bold c-blue fs-30">
                                    Our Vision:
                                  </p>
                                </Col>

                                <Col md={12}>
                                  <p>Be the essential reliable medium in the enrollment, 
                                    exchange and custody of deterministic data, simplifying the interactions of society.
                                  </p>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>

                        <Col md={12}>
                          <Row className="">
                            <Col xs={12} sm={3} md={3}>
                              <img src="./img/rocket.svg" alt="" style={{maxWidth: "150px", width: "100%"}}/>
                            </Col>
                            
                            <Col xs={12} sm={9} md={9}>
                              <Row className="">
                                <Col md={12}>
                                  <p class="fw-bold c-blue fs-30">
                                    Our Mission:
                                  </p>
                                </Col>

                                <Col md={12}>
                                  <p>We develop and integrate the most intelligent, 
                                    secure and avant-garde tools to facilitate digital and analog interactions of our clients.
                                  </p>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>

                    <Col md={12} lg={7} className="right-v video" style={{paddingLeft:"80px", paddingTop:"80px"}}>
                      <div className="aspect-ratio-16:9">
                        <iframe 
                        width="727" 
                        height="409" 
                        src="https://www.youtube.com/embed/RGR6dhOk1DQ" 
                        frameborder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                        allowfullscreen
                        class="w-100 aspect-ratio-item"
                        >
                        </iframe>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>

          </Seccion>

          <Seccion theme='white' epicBarDirection="left" id="dicio-business">
            <Row className="c-bisness" style={{padding:"0 90px"}}>
              
              <Business></Business>

            </Row>

          </Seccion>

          <Seccion theme='dark' id="dicio-team">

            <div className="paralax pad-btm-team" style={{position:"relative"}}>
              <div>
                <div className=" c-white ">
                  <Row className="team-cont" style={{paddingLeft:"40px"}}>
                    <Col md={12} className="center mrg-bottom-40">
                      <h2 class=" title c-white mrg-bt-10 line-height-title letter-spacing-3px mrg-right-60 fw-black fs-60">
                        OUR TEAM
                      </h2>
                    </Col>

                    <Col md={12} className="" >
                      <Row className="" regular="twins, 1024" style={{paddingBottom:"80px"}}>
                        <Col sm={12}lg={4} className="twins imgGrande" style={{height: "420px", paddingLeft:"0"}}>
                          <div className="team-picture-current bg-img-cover" id="imgPrincipal" style={{backgroundImage: "url(./img/team/mike.jpg)"}}>
                            <div class="team-picture-data user-select-none">
                              <Row class="">
                                <Col md={12} class="" >
                                  <p class="data fw-bold fs-22">
                                    <a href="https://www.linkedin.com/in/miguel-espinosa-rescala-a8517566/" target="_blank" class="c-white" id="cambioNombre">
                                      <i class="fab fa-linkedin mrg-right-10 fs-18">
                                      </i>
                                      Miguel Ángel Espinosa
                                    </a>
                                  </p>
                                </Col>
                                
                                <Col md={12} class="">
                                  <p class="data fs-18 c-blue" id="puesto">
                                    Chief Executive Officer
                                  </p>
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </Col>

                        <Col sm={12} lg={8} className="twins imgPequeñas" style={{height: "420px", paddingRight:"0"}}>
                          <Row className=" pad-bottom-10">
                            <Col xs={4} sm={4} md={2} className="mike">
                              <div class="team-picture bg-img-cover null" id="mike" style={{backgroundImage: "url(./img/team/mike.jpg)", height: "100px"}} onClick={() => cambiarImg(1)}  proportional="square, static"></div>
                            </Col>

                            <Col xs={4} sm={4} md={2} className="ricardo">
                              <div class="x:scol-3 s:scol-2">
                                <div class="team-picture bg-img-cover null" id="ricardo" style={{backgroundImage: "url(./img/team/ric.jpg)", height: "99px"}} onClick={ () => cambiarImg(2)} proportional="square, static">
                                </div>
                              </div>
                            </Col>

                            <Col xs={4} sm={4} md={2} className="dahir">
                              <div class="x:scol-3 s:scol-2">
                                <div class="team-picture bg-img-cover null" id="dahir" style={{backgroundImage: "url(./img/team/dahir.jpg)", height: "99px"}} onClick={() => cambiarImg(3)} proportional="square, static">
                                </div>
                              </div>
                            </Col>

                            <Col xs={4} sm={4} md={2} className="boris">
                              <div class="x:scol-3 s:scol-2">
                                <div class="team-picture bg-img-cover null" id="boris" style={{backgroundImage: "url(./img/team/boris.jpg)", height: "99px"}} onClick={() => cambiarImg(4)} proportional="square, static">
                                </div>
                              </div>
                            </Col>

                            <Col xs={4} sm={4} md={2} className="tony">
                              <div class="x:scol-3 s:scol-2">
                                <div class="team-picture bg-img-cover null" id="tony" style={{backgroundImage: "url(./img/team/tony.jpg)", height: "99px"}} onClick={() => cambiarImg(5)} proportional="square, static">
                                </div>
                              </div>
                            </Col>

                            <Col xs={4} sm={4} md={2} className="serch">
                              <div class="x:scol-3 s:scol-2">
                                <div class="team-picture bg-img-cover null" id="serch" style={{backgroundImage: "url(./img/team/serch.jpg)", height: "99px"}} onClick={() => cambiarImg(6)} proportional="square, static">
                                </div>
                              </div>
                            </Col>
                          </Row>

                          <Row className="pad-bottom-10">
                            <Col xs={4} sm={4} md={2} className="jc">
                              <div class="x:scol-3 s:scol-2">
                                <div class="team-picture bg-img-cover null" id="jc" style={{backgroundImage: "url(./img/team/jc.jpg)", height: "99px"}} onClick={() => cambiarImg(7)} proportional="square, static">
                                </div>
                              </div>
                            </Col>

                            <Col xs={4} sm={4} md={2} className="cass">
                              <div class="x:scol-3 s:scol-2">
                                <div class="team-picture bg-img-cover null" id="cass" style={{backgroundImage: "url(./img/team/cass.jpg)", height: "99px"}} onClick={() => cambiarImg(8)} proportional="square, static">
                                </div>
                              </div>
                            </Col>

                            <Col xs={4} sm={4} md={2} className="rayo">
                              <div class="x:scol-3 s:scol-2">
                                <div class="team-picture bg-img-cover null" id="rayo" style={{backgroundImage: "url(./img/team/rayo.jpg)", height: "99px"}} onClick={() => cambiarImg(9)} proportional="square, static">
                                </div>
                              </div>
                            </Col>

                            <Col xs={4} sm={4} md={2} className="anni">
                              <div class="x:scol-3 s:scol-2">
                                <div class="team-picture bg-img-cover null" id="anni" style={{backgroundImage: "url(./img/team/annie.jpg)", height: "99px"}} onClick={() => cambiarImg(10)} proportional="square, static">
                                </div>
                              </div>
                            </Col>

                            <Col xs={4} sm={4} md={2} className="mich">
                              <div class="x:scol-3 s:scol-2">
                                <div class="team-picture bg-img-cover null" id="mich" style={{backgroundImage: "url(./img/team/mich.jpg)", height: "99px"}} onClick={() => cambiarImg(11)} proportional="square, static">
                                </div>
                              </div>
                            </Col>

                            <Col xs={4} sm={4} md={2} className="sensei">
                              <div class="x:scol-3 s:scol-2">
                                <div class="team-picture bg-img-cover null" id="sensei" style={{backgroundImage: "url(./img/team/armando.jpg)", height: "99px"}} onClick={() => cambiarImg(12)} proportional="square, static">
                                </div>
                              </div>
                            </Col>
                          </Row>

                          <Row style={{paddingBottom:"10px"}}>
                            <Col xs={4} sm={4} md={2} className="oscar">
                              <div class="x:scol-3 s:scol-2">
                                <div class="team-picture bg-img-cover null" id="oscar" style={{backgroundImage: "url(./img/team/oscar.jpg)", height: "99px"}} onClick={() => cambiarImg(13)} proportional="square, static">
                                </div>
                              </div>
                            </Col>

                            <Col xs={4} sm={4} md={2} className="alex">
                              <div class="x:scol-3 s:scol-2">
                                <div class="team-picture bg-img-cover null" id="alex" style={{backgroundImage: "url(./img/team/alex.jpg", height: "99px"}} onClick={() => cambiarImg(14)} proportional="square, static">
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              
                
              </div>
            </div>

          </Seccion>
        
        </div>
      </div>

      <Footer></Footer>
    </div>

  );
}


export default (Nosotros)